module.exports = __webpack_public_path__ + "static/media/loading-green.1ecaf857.svg";